module.exports = __webpack_public_path__ + "static/media/iconLungs.36a24ced.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconLungs.svg
// module id = 211
// module chunks = 0